export default "__VITE_PUBLIC_ASSET__60143e4e__"